
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalLoginHistory from '@/components/templates/ModalLoginHistory.vue'
import { LoginHistory } from '@/models/LoginHistory'
import { StudentLoginHistoriesApi } from '@/api/methods/StudentLoginHistoriesApi'

/**
 * 生徒ログイン履歴モーダル
 */
@Component({
  components: {
    ModalLoginHistory,
  },
})
export default class ModalStudentLoginHistory extends Vue {
  /** ログイン履歴モーダル */
  @Ref()
  modalLoginHistory!: ModalLoginHistory

  /** ログイン履歴一覧 */
  private loginHistoryList: LoginHistory[] = []

  /**
   * ログイン履歴一覧を取得し、モーダルを開く
   */
  public async show(): Promise<void> {
    this.$loading.start()
    // ログイン履歴一覧取得
    const responseHistory = await StudentLoginHistoriesApi.getList()
    this.loginHistoryList = responseHistory.map((history) => {
      return {
        date: new Date(history.date * 1000),
      }
    })
    this.$loading.complete()
    this.modalLoginHistory.show()
  }
}
